const ColorPicker = () => {
  const orangeShades = [
    { name: "Orange 500", class: "bg-orange-500", hex: "#f97316" },
    { name: "Orange 600", class: "bg-orange-600", hex: "#ea580c" },
    { name: "Orange 700", class: "bg-orange-700", hex: "#c2410c" },
    { name: "Amber 500", class: "bg-amber-500", hex: "#f59e0b" },
    { name: "Amber 600", class: "bg-amber-600", hex: "#d97706" },
    { name: "Amber 700", class: "bg-amber-700", hex: "#b45309" },
    { name: "Yellow 500", class: "bg-yellow-500", hex: "#eab308" },
    { name: "Yellow 600", class: "bg-yellow-600", hex: "#ca8a04" },
    { name: "Red Orange 500", class: "bg-red-500", hex: "#ef4444" },
    { name: "Red Orange 600", class: "bg-red-600", hex: "#dc2626" },
    { name: "Custom Deep Orange", class: "bg-orange-800", hex: "#9a3412" },
    { name: "Custom Burnt Orange", class: "bg-red-700", hex: "#b91c1c" },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">
          Choose Your Orange Shade
        </h1>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {orangeShades.map((shade, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 shadow-lg text-center"
            >
              <div
                className={`w-20 h-20 ${shade.class} rounded-lg mx-auto mb-4`}
              ></div>
              <h3 className="font-semibold mb-2">{shade.name}</h3>
              <p className="text-sm text-gray-600 mb-4">{shade.hex}</p>

              {/* Sample Button */}
              <button
                className={`${shade.class} hover:opacity-90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-opacity`}
              >
                Sample Button
              </button>

              {/* Sample Text */}
              <div
                className={`mt-3 font-semibold ${shade.class.replace(
                  "bg-",
                  "text-"
                )}`}
              >
                Sample Text
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Click on any shade name to see the CSS class:
          </p>
          <div className="bg-white p-4 rounded-lg shadow inline-block">
            <code className="text-sm">
              Example: .btn-primary &#123; @apply bg-orange-600
              hover:bg-orange-700; &#125;
            </code>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorPicker;
